import React from 'react';

import Grid from '@atlaskit/grid/grid';
import { GridContainer } from '@atlaskit/grid/grid-container';
import { GridItem } from '@atlaskit/grid/grid-item';

import { SkeletonBox } from './shared/skeleton-box';

export default (): React.JSX.Element => {
	return (
		<GridContainer hasInlinePadding={true}>
			<Grid>
				<GridItem span={{ md: 6 }}>
					<SkeletonBox>md=6</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 6 }}>
					<SkeletonBox>md=6</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 6 }}>
					<SkeletonBox>md=6</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 6 }}>
					<SkeletonBox>md=6</SkeletonBox>
				</GridItem>
			</Grid>
			<Grid>
				<GridItem span={{ md: 4 }}>
					<SkeletonBox>md=4</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 8 }}>
					<SkeletonBox>md=8</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 4 }}>
					<SkeletonBox>md=4</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 8 }}>
					<SkeletonBox>md=8</SkeletonBox>
				</GridItem>
			</Grid>
			<Grid>
				<GridItem span={{ md: 4 }}>
					<SkeletonBox>md=4</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 8 }}>
					<SkeletonBox>md=8</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 4 }}>
					<SkeletonBox>md=4</SkeletonBox>
				</GridItem>
				<GridItem span={{ md: 8 }}>
					<SkeletonBox>md=8</SkeletonBox>
				</GridItem>
			</Grid>
		</GridContainer>
	);
};
